import React from "react";
import CreateCategoryGroup from "./CreateCategoryGroup";

const EditCategoryGroup = props => {
  return <CreateCategoryGroup isEdit {...props} />;
};

export default EditCategoryGroup;



// WEBPACK FOOTER //
// ./src/views/Pages/Partnership/EditCategoryGroup.js